<template>
  <div>
    <router-view />
    <ds ds="toast"
      :timeout.prop="4000"
    />
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    isLoading: true
  })
};
</script>

<style lang="less">
  @import '~@/index.less';
</style>
